import React from 'react';
import { Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import styles from './styles';

type Props = {
  onClick: () => void;
};

const CloseAction = ({ onClick }: Props) => {
  const classes = styles();

  return (
    <Button aria-label="close" className={classes.closeButton} onClick={onClick}>
      <CloseIcon />
    </Button>
  );
};

export default CloseAction;
